module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Light.c26cd2e.woff2";